import { RootState } from '../../app/store'
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { CompTableData } from '../utils/CompTable'
import { API_BASE } from '../../app/const'
import { fireauth } from '../auth/AuthSlice'

export interface BulkUploadrState {
  status: 'idle' | 'loading' | 'failed'
  data: any
  fault: any
  historyStatus: 'idle' | 'loading' | 'failed'
  history: any
  historyItemStatus: 'idle' | 'loading' | 'failed'
  historyItemDetail: any
  preSignedUrlStatus: 'idle' | 'loading' | 'failed'
  preSignedUrl: any
  bulkSamplesStatus: 'idle' | 'loading' | 'failed'
  bulkSamples?: { [key: string]: string }
}

export interface BulkUpload {
  id: string,
  size: number,
  submitDate: number,
  status: string // QUEUED|PROCESSING|COMPLETED
}
const initialState: BulkUploadrState = {
  status: 'idle',
  data: '',
  fault: '',
  historyStatus: 'idle',
  history: '',
  historyItemStatus: 'idle',
  historyItemDetail: '',
  preSignedUrlStatus: 'idle',
  preSignedUrl: '',
  bulkSamplesStatus: 'idle',
}

export const bulkUploadSamplesAsync = createAsyncThunk('bulkUploadr/samples', async (_, { getState }) => {
  const state = getState() as RootState
  return axios.get(`${API_BASE}apps/bulk/samples`, {
    headers: {
      "Authorization": `Bearer ${await fireauth.currentUser?.getIdToken()}`
    }
  }).then((response) => {
    return response
  })
})

export const bulkUploadAsync = createAsyncThunk('bulkUploadr/upload', async ({ form, template }: { form: FormData, template: string }, { getState }) => {
  const state = getState() as RootState
  return axios.post(`${API_BASE}apps/bulk?template=${template ? template : 'SIMPLE'}`, form, {
    headers: {
      "Authorization": `Bearer ${await fireauth.currentUser?.getIdToken()}`
    }
  }).then((response) => {
    return response
  })
})

export const fetchHistory = createAsyncThunk('bulkUploadr/history', async (args: any, { getState }) => {
  //export const loadHistoryAsync = createAsyncThunk('bulkUploadr/history', async ({ }, { getState }) => {
  console.log(`History Asycn...##`)
  const state = getState() as RootState
  return axios.get(`${API_BASE}apps/bulk/history`, {
    headers: {
      "Authorization": `Bearer ${await fireauth.currentUser?.getIdToken()}`
    }
  })
})

export const fetchHistoryItemDetail = createAsyncThunk('bulkUploadr/historyItemDetail', async ({ slug }: { slug: string }, { getState }) => {
  const state = getState() as RootState
  return axios.get(`${API_BASE}apps/bulk/${slug}`, {
    headers: {
      "Authorization": `Bearer ${await fireauth.currentUser?.getIdToken()}`
    }
  })
})

export const fetchPreSignedUrl = createAsyncThunk('bulkUploadr/fetchPreSignedUrl', async ({ slug }: { slug: string }, { getState }) => {
  const state = getState() as RootState
  return axios.get(`${API_BASE}apps/presigned/${slug}`, {
    headers: {
      "Authorization": `Bearer ${await fireauth.currentUser?.getIdToken()}`
    }
  })
})

export const bulkUploadrSlice = createSlice({
  name: 'bulkUploadr',
  initialState,
  reducers: {
    bulkUploadReset: (state, action: PayloadAction<any>) => {
      state.data = initialState.data
      state.status = 'idle'
    },
  }, extraReducers: (builder) => {
    builder.addCase(bulkUploadAsync.pending, (state, action) => {
      state.status = 'loading'
    })
      .addCase(bulkUploadAsync.fulfilled, (state, action) => {
        state.status = 'idle'
        state.data = (action.payload as any).data
      })
      .addCase(bulkUploadAsync.rejected, (state, action) => {
        state.status = 'idle'
        state.data = ''
        state.fault = action.error.message
      })
      .addCase(fetchHistory.pending, (state, action) => {
        state.historyStatus = 'loading'
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.historyStatus = 'idle'
        state.history = (action.payload as any).data
      })
      .addCase(fetchHistory.rejected, (state, action) => {
        state.historyStatus = 'idle'
        state.history = ''
      })
      .addCase(fetchHistoryItemDetail.pending, (state, action) => {
        state.historyItemStatus = 'loading'
      })
      .addCase(fetchHistoryItemDetail.fulfilled, (state, action) => {
        state.historyItemStatus = 'idle'
        state.historyItemDetail = (action.payload as any).data
      })
      .addCase(fetchHistoryItemDetail.rejected, (state, action) => {
        state.historyItemStatus = 'idle'
        state.historyItemDetail = ''
      }).addCase(fetchPreSignedUrl.pending, (state, action) => {
        state.preSignedUrlStatus = 'loading'
      }).addCase(fetchPreSignedUrl.fulfilled, (state, action) => {
        state.preSignedUrlStatus = 'idle'
        state.preSignedUrl = (action.payload as any).data
      }).addCase(fetchPreSignedUrl.rejected, (state, action) => {
        state.preSignedUrlStatus = 'idle'
        state.preSignedUrl = ''
      }).addCase(bulkUploadSamplesAsync.pending, (state, action) => {
        state.bulkSamplesStatus = 'loading'
      }).addCase(bulkUploadSamplesAsync.fulfilled, (state, action) => {
        state.bulkSamplesStatus = 'idle'
        state.bulkSamples = (action.payload as any).data
      }).addCase(bulkUploadSamplesAsync.rejected, (state, action) => {
        state.bulkSamplesStatus = 'idle'
        state.bulkSamples = {}
      })
  }
})

export default bulkUploadrSlice.reducer
export const selectBulkUploadrData = (state: RootState) => state.bulkUploadr.data
export const selectBulkUploadrHistory = (state: RootState) => state.bulkUploadr.history
export const selectBulkUploadrHistoryItemDetail = (state: RootState) => state.bulkUploadr.historyItemDetail
export const selectPreSignedUrl = (state: RootState) => state.bulkUploadr.preSignedUrl
export const selectBulkSamples = (state: RootState) => state.bulkUploadr.bulkSamples
export const selectBulkSamplesStatus = (state: RootState) => state.bulkUploadr.bulkSamplesStatus
export const { bulkUploadReset } = bulkUploadrSlice.actions